"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailToolbarButton = void 0;
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const tooltip_1 = require("../../components/tooltip/tooltip");
const detail_types_1 = require("./detail-types");
const useStyles = makeStyles_1.default((theme) => ({
    toolbarButton: {
        height: '100%',
        minWidth: 40,
        cursor: 'pointer',
        padding: '4px 10px',
        border: 0,
        backgroundColor: '#e0e0e0',
        '&:hover': {
            backgroundColor: '#d0d0d0',
        },
    },
    toolbarMainButton: {
        height: '100%',
        minWidth: 40,
        cursor: 'pointer',
        padding: '4px 10px',
        boxShadow: '0 0 0',
        border: 0,
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
            border: 0,
            backgroundColor: theme.palette.primary.dark,
        },
    },
    toolbarWarningButton: {
        border: 0,
        padding: '4px 10px',
        backgroundColor: `${theme.palette.error.dark}40`,
        '&:hover': {
            border: 0,
            backgroundColor: `${theme.palette.error.dark}60`,
        },
    },
    toolbarDisabledButton: {
        borderTop: '0 !important',
        borderBottom: '0 !important',
        borderRight: '0 !important',
        borderLeft: 'inherit !important',
        backgroundColor: '#e0e0e0 !important',
    },
    toolbarButtonLabel: {
        flexDirection: 'column',
        fontSize: 12,
        fontWeight: 600,
        width: 60,
    },
    toolbarButtonIcon: {
        margin: 0,
    },
}));
function DetailToolbarButton({ label, tooltip, disabled, onClick, href, type = detail_types_1.DetailToolbarButtonType.NORMAL, startIcon, endIcon, ...restProps }) {
    const classes = useStyles();
    const buttonProps = { ...restProps };
    if (type === detail_types_1.DetailToolbarButtonType.PRIMARY) {
        buttonProps.color = 'primary';
        buttonProps.variant = 'outlined';
        buttonProps.classes = {
            root: classes.toolbarMainButton,
            disabled: classes.toolbarDisabledButton,
            label: classes.toolbarButtonLabel,
            startIcon: classes.toolbarButtonIcon,
        };
    }
    else if (type === detail_types_1.DetailToolbarButtonType.SECONDARY) {
        buttonProps.color = 'secondary';
        buttonProps.variant = 'outlined';
        buttonProps.classes = {
            root: classes.toolbarWarningButton,
            disabled: classes.toolbarDisabledButton,
            label: classes.toolbarButtonLabel,
            startIcon: classes.toolbarButtonIcon,
        };
    }
    return (react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip, placement: "top-start" },
        react_1.default.createElement(Button_1.default, Object.assign({ onClick: onClick, href: href, disabled: disabled, classes: {
                root: classes.toolbarButton,
                disabled: classes.toolbarDisabledButton,
                label: classes.toolbarButtonLabel,
                startIcon: classes.toolbarButtonIcon,
            }, variant: "outlined" }, buttonProps, { startIcon: startIcon, endIcon: endIcon }), label)));
}
exports.DetailToolbarButton = DetailToolbarButton;
//# sourceMappingURL=detail-toolbar-button-2.js.map